<template>
  <footer
    class="footer-parallax-overlay footer-classic context-dark parallax-container"
    :data-parallax-img="
      getContent(
        layoutContent?.currentLocaleData,
        layoutContent?.defaultLocaleData,
        'backgroundImage'
      )
    "
  >
    <div class="parallax-content">
      <div class="section-sm">
        <div class="container">
          <div class="row row-30">
            <div class="col-md-6 col-lg-4">
              <div class="footer-classic-item">
                <h4>
                  {{
                    getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      "firstColumn.title"
                    )
                  }}
                </h4>
                <p>
                  {{
                    getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      "firstColumn.description"
                    )
                  }}
                </p>
                <ul class="list-inline list-inline-xs list-inline-middle">
                  <li
                    v-for="social in getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      'firstColumn.socials'
                    )"
                    :key="social.url"
                  >
                    <AtomicLink
                      class="icon-square novi-icon"
                      :class="`fa-${social.icon}`"
                      :href="social.url"
                      :targetBlank="social.targetBlank"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="footer-classic-item">
                <h4>
                  {{
                    getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      "secondColumn.title"
                    )
                  }}
                </h4>
                <div class="list-terms">
                  <dl
                    v-for="(item, index) in getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      'secondColumn.items'
                    )"
                    :key="index"
                  >
                    <dt>{{ item.days }}</dt>
                    <dd>{{ item.hours }}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="footer-classic-item">
                <h4>
                  {{
                    getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      "thirdColumn.title"
                    )
                  }}
                </h4>
                <ul class="list-contacts">
                  <li class="centered">
                    <span
                      class="icon icon-lg icon-secondary mdi mdi-cellphone-android novi-icon"
                    />
                    <a
                      class="link-phone"
                      :href="`tel:${getContent(
                        layoutContent?.currentLocaleData,
                        layoutContent?.defaultLocaleData,
                        'thirdColumn.phone'
                      )}`"
                    >
                      {{
                        getContent(
                          layoutContent?.currentLocaleData,
                          layoutContent?.defaultLocaleData,
                          "thirdColumn.phone"
                        )
                      }}
                    </a>
                  </li>
                  <li class="centered">
                    <span
                      class="icon icon-lg icon-secondary mdi mdi-email-outline novi-icon"
                    />
                    <a
                      :href="`mailto:${getContent(
                        layoutContent?.currentLocaleData,
                        layoutContent?.defaultLocaleData,
                        'thirdColumn.email'
                      )}`"
                    >
                      {{
                        getContent(
                          layoutContent?.currentLocaleData,
                          layoutContent?.defaultLocaleData,
                          "thirdColumn.email"
                        )
                      }}
                    </a>
                  </li>
                  <li>
                    <span
                      class="icon icon-xl icon-secondary mdi mdi-map-marker novi-icon"
                    />
                    <span>
                      {{
                        getContent(
                          layoutContent?.currentLocaleData,
                          layoutContent?.defaultLocaleData,
                          "thirdColumn.address"
                        )
                      }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-classic-bottom">
        <div class="container">
          <p class="rights">
            <span>&copy;&nbsp;</span>
            <span>{{ new Date().getFullYear() }}</span>
            <span>&nbsp;</span>
            <span>{{
              getContent(
                layoutContent?.currentLocaleData,
                layoutContent?.defaultLocaleData,
                "copyrightsLabel"
              )
            }}</span>
            <!-- <span>.&nbsp;</span>
            <a href="privacy-policy.html">Privacy Policy</a> -->
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const { getContent } = useProjectMethods();

const contentParams = {
  contentKey: "layoutContent",
  contentRoute: ["layout", "footer"],
};

const { getContentData } = useContentLogic(contentParams);
const { data: layoutContent } = await useLazyAsyncData(getContentData);
</script>

<style scoped>
.footer-parallax-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--home-page-parallax-overlay-bg);
}
</style>
